import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Grid as BaseGrid } from '@/components/Grid';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import type { Maybe } from '@/lib/types';
import { theme } from '@/theme';
export const BackgroundWrapper = styled(Box)<{
  storyBackgroundColor: Maybe<string>;
}>`
  ${({ storyBackgroundColor, theme }) => css`
    background-color: ${storyBackgroundColor || theme.colors.lightGrey};
  `}
`;
export const Grid = styled(BaseGrid)<{
  $loading: boolean;
  mediaReversed?: boolean;
  storyBackgroundColor: Maybe<string>;
}>`
  grid-template-columns: 1fr;
  ${({ $loading, mediaReversed, storyBackgroundColor, theme }) => css`
    padding: ${theme.spacing(3, 0)};
    img {
      order: ${mediaReversed ? -1 : 1};
    }
    ${theme.media.md.down} {
      grid-template-rows: auto auto;
      row-gap: 16px;
    }
    ${theme.media.md.up} {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 70px;
      background-color: ${storyBackgroundColor || theme.colors.lightGrey};
      padding-top: ${theme.spacing(4)};
      padding-bottom: ${theme.spacing(4)};
    }
    ${$loading &&
    css`
      && {
        grid-template-columns: 1fr;
      }
    `}
  `}
`;
export const StoryWrapper = styled(Box)<{
  $loading: boolean;
  mediaReversed?: boolean;
}>`
  ${({ mediaReversed, theme }) => css`
    ${theme.media.md.down} {
      h3 {
        text-align: center;
      }
    }
    ${theme.media.md.up} {
      order: ${mediaReversed ? -1 : 1};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    ${theme.media.lg.up} {
      order: ${mediaReversed ? -1 : 1};
    }
  `}
`;
export const Picture = styled(NextImageWithLoader)<{ bgColor?: string }>`
  .next-image {
    object-fit: contain;
    object-position: right top;
    width: 100%;
    height: 100%;
    ${({ bgColor, theme }) => css`
      background-color: ${bgColor ?? theme.colors.black};
      ${theme.media.md.down} {
        max-height: 800px;
      }
      ${theme.media.md.down} {
        max-height: 500px;
      }
      ${theme.media.md.up} {
        margin-left: auto;
        height: auto;
        max-height: 525px;
      }
    `}
  }
`;
export const ImageWrapper = styled(Box)`
  max-height: 430px;
`;
export const MediaWrapper = styled(Box)`
  position: relative;
`;
export const PlayCircleSvgWrapper = styled(Box)`
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  z-index: 100;
`;
export const HeadingWrapper = styled(Box)`
  width: 100%;
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(3)};
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(2.5)};
    }
  `}
`;
export const ReadMoreButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.primaryDark};
  cursor: pointer;
  font-size: ${theme.fontSizes.p2};
  text-decoration: underline;
  display: inline;
  margin: 0;
  margin-left: ${theme.spacing(1)};
  padding: 0;
  white-space: nowrap;
  text-decoration: underline;
`;
